module.exports = __webpack_public_path__ + "static/media/night04.8f0647da.jpg";